export default "__VITE_ASSET__CD1tc1wD__"